module.exports = __webpack_public_path__ + "media/team/Sam-Thumbnail-6b10816c.png";